export enum SuccessfulEnum {
  SUCCESS = 'SUCCESS',
  QUEUE = 'QUEUE',
  PENDING = 'PENDING',
  FAIL = 'FAIL',
}
